import { Injectable } from "@angular/core";
import { AppConfigService } from "@master/core/dist/core";

@Injectable({
  providedIn: "root",
})
export class BaseService {
  private configServerURL: string;

  constructor(public appConfigService: AppConfigService) {
    const installationNameFolder = this.appConfigService.getConfig().installationNameFolder;
    this.configServerURL = `${this.appConfigService.getConfig().serverURL}${installationNameFolder != "" ? installationNameFolder: '/'}api`;

  }


  /**
   * Return base api url
   * @returns
   */
  public getUrl() {
	return this.configServerURL
  }




}
